// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"151e7477","453":"f1bb2d69"}[chunkId] + ".chunk.js";
};